import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import ServiceAccountingAutocomplete from '~/integrations/Accounting/ServiceAccountingAutocomplete/ServiceAccountingAutocomplete';
const ServiceAccountingField = (param)=>{
    let { testId, accounting, accountingItems, isDisabled, controlName, isBundle } = param;
    const { control } = useFormContext();
    return /*#__PURE__*/ _jsx(Controller, {
        name: controlName,
        control: control,
        render: (param)=>{
            let { field: { value: serviceMapping, onChange } } = param;
            return /*#__PURE__*/ _jsx(ServiceAccountingAutocomplete, {
                testId: testId,
                isDisabled: isDisabled,
                accountingItems: accountingItems,
                selectedOption: serviceMapping.type === 'mapped' ? serviceMapping.mappedItem : null,
                showAccountingMapPlaceHolder: true,
                accounting: accounting,
                onItemChange: (item)=>onChange(item ? {
                        type: 'mapped',
                        mappedItem: item
                    } : {
                        type: 'unmapped'
                    }),
                isBundle: isBundle
            });
        }
    });
};
export default ServiceAccountingField;
